export const PREPARING_LESSON_REPORT_TEXT =
  'Preparing Lesson Report (This could take a minute)'
export const DOWNLOAD_LESSON_REPORT_TEXT = 'Download Lesson Report (CSV)'
